import CookiePreferenceStore from 'components/CookiePreferences/store';
import {gdprPreferencesTranslations} from 'helpers/translations';

export default new CookiePreferenceStore({
  translations: gdprPreferencesTranslations
});